const sessionStorageItemsEnum = {
   bearer_token: 'bearer_token',
   refresh_token: 'refresh_token',
   client_access_token: 'client_access_token',
   consultant_id: 'consultant_id',
   consultant_first_name: 'consultant_first_name',
   consultant_last_name: 'consultant_last_name',
   redirect_page_name: 'redirect_page_name',
   redirect_page_params: 'redirect_page_params',
   redirect_page_full_path: 'redirect_page_full_path',
   user_access_token: 'user_access_token',
   expire_date: 'expire_date',
};

export default Object.freeze(sessionStorageItemsEnum);
